import { GetCouponResponse } from './api-services/get-coupon.service';

/**
 * 注文単位値引クーポン登録画面の値を管理するクラス
 *
 * @export KYMW7301Model
 * @class KYMW7301Model
 */
export class KYMW7301Model {
  public couponGoodsNo: string = <string>'';
  public couponCategory: string = <string>'';
  public couponOrderCd: string = <string>'';
  public noticeExistenceType: string = <string>'';
  public noticeMethodTypeItem: string = <string>'';
  public noticeMethodTypeMail: string = <string>'';
  public useStandardPrice: string = <string>'';
  public startMemberWeek: string = <string>'';
  public endMemberWeek: string = <string>'';
  public couponIssueCatalogStart: string = <string>'';
  public couponIssueCatalogEnd: string = <string>'';
  public validWeek: string = <string>'';
  public couponReceiptCatalogStart: string = <string>'';
  public couponReceiptCatalogEnd: string = <string>'';
  public discountPrice: string = <string>'';
  public couponName: string = <string>'';
  public couponNameKana: string = <string>'';
  public ecTitle: string = <string>'';
  public detailsTitle: string = <string>'';
  public useTerms: string = <string>'';
  public discountedAmount: string = <string>'';
  public validatedDate: string = <string>'';
  public cpgrpCd: string = <string>'';
  public coopCodeList: string[] = [];

  public allCoop = Boolean(false);
  public ibaraki = Boolean(false);
  public tochigi = Boolean(false);
  public gunma = Boolean(false);
  public chiba = Boolean(false);
  public saitama = Boolean(false);
  public tokyo = Boolean(false);
  public nagano = Boolean(false);
  public niigata = Boolean(false);

  public typeItem = Boolean(false);
  public typeMail = Boolean(false);

  public couponCategoryChangeFlg: string = <string>'0';
  public changeOtherCatalogEndFlg: string = <string>'0';

  // 前画面から受け取ったモード
  public mode: string = <string>'';

  /**
   * クーポン情報検索結果の画面反映
   */
  public setSearchResult(serverData: GetCouponResponse): void {
    this.couponCategory = serverData.CouponCategory;
    this.couponOrderCd = serverData.CouponOrderCd;
    this.noticeExistenceType = serverData.NoticeExistenceType;
    this.noticeMethodTypeItem = serverData.NoticeMethodTypeItem;
    this.noticeMethodTypeMail = serverData.NoticeMethodTypeMail;
    this.useStandardPrice = serverData.UseStandardPrice;
    this.startMemberWeek = serverData.StartMemberWeek;
    this.endMemberWeek = serverData.EndMemberWeek;
    this.couponIssueCatalogStart = serverData.CouponIssueCatalogStart;
    this.couponIssueCatalogEnd = serverData.CouponIssueCatalogEnd;
    this.validWeek = serverData.ValidWeek;
    this.couponReceiptCatalogStart = serverData.CouponReceiptCatalogStart;
    this.couponReceiptCatalogEnd = serverData.CouponReceiptCatalogEnd;
    this.discountPrice = serverData.DiscountPrice;
    this.couponName = serverData.CouponName;
    this.couponNameKana = serverData.CouponNameKana;
    this.ecTitle = serverData.EcTitle;
    this.detailsTitle = serverData.DetailsTitle;
    this.useTerms = serverData.UseTerms;
    this.discountedAmount = serverData.DiscountedAmount;
    this.validatedDate = serverData.ValidatedDate;
    this.cpgrpCd = serverData.CpgrpCd;
    this.couponGoodsNo = serverData.CouponGoodsNo;
    serverData.CoopCodeList.map(_ => this.coopCodeList.push(_.CoopCode));
  }

}
